var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C6.98122 0 5.75 1.23122 5.75 2.75V3.5C5.75 3.58427 5.75379 3.66766 5.76121 3.75H1.25C0.559644 3.75 0 4.30964 0 5C0 5.69036 0.559644 6.25 1.25 6.25H2.76121C2.75379 6.33234 2.75 6.41573 2.75 6.5V17.25C2.75 18.7688 3.98122 20 5.5 20H14.5C16.0188 20 17.25 18.7688 17.25 17.25V6.5C17.25 6.41573 17.2462 6.33234 17.2388 6.25H18.75C19.4404 6.25 20 5.69036 20 5C20 4.30964 19.4404 3.75 18.75 3.75H14.2388C14.2462 3.66766 14.25 3.58427 14.25 3.5V2.75C14.25 1.23122 13.0188 0 11.5 0H8.5ZM11.5 3.75C11.6381 3.75 11.75 3.63807 11.75 3.5V2.75C11.75 2.61193 11.6381 2.5 11.5 2.5H8.5C8.36193 2.5 8.25 2.61193 8.25 2.75V3.5C8.25 3.63807 8.36193 3.75 8.5 3.75H11.5ZM5.5 6.25C5.36193 6.25 5.25 6.36193 5.25 6.5V17.25C5.25 17.3881 5.36193 17.5 5.5 17.5H14.5C14.6381 17.5 14.75 17.3881 14.75 17.25V6.5C14.75 6.36193 14.6381 6.25 14.5 6.25H5.5Z",
    fill: "#1F2445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlanc);
export default __webpack_public_path__ + "static/media/deleteBlanc.674bfb65809b9b8d849f26632befdb05.svg";
export { ForwardRef as ReactComponent };